import { ArrowLeft16 } from '@carbon/icons-react';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Modal } from 'components/atoms/modal';
import styles from 'components/atoms/modal/modal.module.css';

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: var(--cp-spacing-04);
  border-radius: var(--border-radius-small);
  :hover {
    background: var(--cp-background-as-black-opacity-02);
  }

  :active {
    background: var(--cp-background-as-black-opacity);
  }

  @media (min-width: 481px) {
    display: none;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
`;

export const CpModal = styled(Modal).attrs((props) => {
  _.set(
    props,
    'okButtonProps.className',
    `${styles.ok_button} cp-modal-ok-button ${props?.okButtonProps?.className}`,
  );
  _.set(
    props,
    'cancelButtonProps.className',
    `${styles.cancel_button} cp-modal-cancel-button ${props?.okButtonProps?.className}`,
  );

  const title = props.title ?? <></>;

  _.set(
    props,
    'title',
    <Title>
      <IconWrapper onClick={props?.onCancel}>
        <ArrowLeft16 />
      </IconWrapper>
      {title}
    </Title>,
  );

  return props;
})`
  @media (max-width: 480px) {
    top: 0;
    transform-origin: 0 0;
    margin-top: 0;
    left: 0;
    margin-left: 0;
    overflow-y: hidden;
    max-width: 100vw;

    .ant-modal-close {
      display: none;
    }

    .ant-modal-content {
      height: 100svh;
      width: 100svw;
    }

    .ant-modal-body {
      padding-top: var(--cp-spacing-05);
      height: calc(100% - 220px);
    }
    .ant-modal-header {
      border-bottom: 1px solid var(--cp-border-subtle);
    }
  }

  .ant-modal-header {
    border-radius: var(--border-radius-small) var(--border-radius-small) 0 0;
  }

  .ant-modal-content {
    border-radius: var(--border-radius-small);
  }

  .ant-modal-footer {
    border-radius: 0 0 var(--border-radius-small) var(--border-radius-small);

    @media (max-width: 480px) {
      flex-direction: column;
      .ant-btn {
        width: 100%;
        &:last-child {
          margin-left: 0;
          margin-top: var(--cp-spacing-04);
        }
      }
    }
  }

  & .cp-modal-ok-button.ant-btn,
  & .cp-modal-cancel-button.ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius-small);
    padding: var(--cp-spacing-04) var(--cp-spacing-06);
    width: 181px;
    box-shadow: none;
    border: none;

    @media (max-width: 480px) {
      width: 100%;
    }
  }

  & .cp-modal-ok-button.ant-btn {
    background: var(--cp-black);
    color: var(--cp-white);

    :hover {
      background: var(--cp-black-opacity-80-hover);
    }

    :active {
      background: var(--cp-black-opacity-90-hover);
    }
  }

  & .cp-modal-cancel-button.ant-btn {
    background: var(--cp-background-as-black-opacity-02);
    color: var(--cp-text-primary);

    :hover {
      background: var(--cp-background-as-black-opacity);
    }

    :active {
      background: var(--cp-background-as-black-opacity-02);
    }
  }

  & .cp-modal-ok-button[iconplacement='right'] {
    svg {
      margin-right: 0;
      margin-left: var(--spacing-04);
    }
  }
  .cp-modal-ok-button&[iconplacement='left'] {
    svg {
      margin-left: 0;
      margin-right: var(--spacing-04);
    }
  }

  & .cp-modal-cancel-button[iconplacement='right'] {
    svg {
      margin-right: 0;
      margin-left: var(--spacing-04);
    }
  }
  .cp-modal-cancel-button&[iconplacement='left'] {
    svg {
      margin-left: 0;
      margin-right: var(--spacing-04);
    }
  }
`;
